import { useState } from 'react';
import Fab from '@material-ui/core/Fab';
import IconButton from '@material-ui/core/IconButton';
import { useTheme } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import DataTableNativeML from '@/components/DataTableNativeML';
import ButtonTip from '@/components/buttonTip/ButtonTip';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import DialogDataML from '@/components/DialogDataML/DialogDataML';
import ResultListStyled from './ResultListStyled';
const ResultList = (props) => {
  const theme = useTheme();
  const {
    handlePageChange,
    pageData,
    listLoading,
    handleClickRow,
    handleClickDelete,
    openDialog,
    setOpenDialog,
  } = props;
  //列表数据
  const { data, total } = props?.tableData || {};
  const [currentAction, setCurrentAction] = useState({});

  const columns = [
    {
      align: 'center',
      title: '人员编号',
      id: 'empNo',
      key: 'empNo',
      width: 180,
    },
    {
      align: 'center',
      title: '人员姓名',
      id: 'empName',
      key: 'empName',
      width: 180,
    },
    {
      align: 'center',
      title: '所在部门',
      id: 'depNames',
      key: 'depNames',
      width: 220,
    },
    {
      align: 'center',
      title: '状态',
      id: 'status',
      key: 'status',
      width: 170,
      render: (rowInfo) => {
        return <div>{rowInfo.status === 'ENABLE' ? '可用' : '冻结'}</div>;
      },
    },
    {
      align: 'center',
      title: '更新时间',
      id: 'updateDate',
      key: 'updateDate',
      width: 170,
    },

    {
      title: '操作',
      align: 'center',
      // id: 'mobile',
      // key: 'mobile',
      width: 140,
      render: (rowInfo) => {
        return (
          <div align="center" className="handle_btn">
            <ButtonTip title="编辑">
              <IconButton
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={() => {
                  handleClickRow(rowInfo, 'edit');
                }}
              >
                <SvgIconML
                  name="edit"
                  size={24}
                  fill={theme.palette.primary.main}
                />
              </IconButton>
            </ButtonTip>
            <ButtonTip title="详情">
              <IconButton
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={() => {
                  handleClickRow(rowInfo, 'detail');
                }}
              >
                <SvgIconML
                  name="detail"
                  size={24}
                  fill={theme.palette.primary.main}
                  className="preview"
                />
              </IconButton>
            </ButtonTip>

            <ButtonTip title="删除">
              <IconButton
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                // 删除
                onClick={() => {
                  setOpenDialog(true);
                  setCurrentAction({
                    dialogTitle: '删除',
                    dialogContent: '确认要删除员工吗？',
                    confirm: () => handleDelete(rowInfo),
                  });
                }}
              >
                <SvgIconML
                  name="circleDelete"
                  size={22}
                  fill={theme.palette.primary.main}
                  className="preview"
                />
              </IconButton>
            </ButtonTip>
          </div>
        );
      },
    },
  ];

  const handleDelete = (rowInfo) => {
    console.log('删除', rowInfo);
    handleClickDelete(rowInfo);
  };

  const handleAddIssuance = () => {
    handleClickRow({}, 'add');
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return (
    <ResultListStyled>
      <div className="export-wrapper">
        <Fab
          variant="extended"
          size="small"
          color="primary"
          aria-label="add"
          className="export"
          onClick={handleAddIssuance}
        >
          <AddIcon sx={{ width: '24px', height: '24px' }} />
          新建员工
        </Fab>
      </div>
      <DataTableNativeML
        loading={listLoading}
        columns={columns}
        changePage={handlePageChange}
        page={pageData}
        // page={searchParam}
        paging={true}
        data={data}
        total={total}
        columnKey="id"
      ></DataTableNativeML>
      <DialogDataML
        open={openDialog}
        title={currentAction?.dialogTitle}
        content={currentAction?.dialogContent}
        handleClose={handleCloseDialog}
        handleConfirm={currentAction?.confirm}
      ></DialogDataML>
    </ResultListStyled>
  );
};
export default ResultList;
